const { showError, showNotifikasi } = require('../../libs/helper');

module.exports = {
  getData: (g, params) => {
    return g.$http({
      url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/pengembalian/list',
      method: 'post',
      params
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
            showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)

          return res.data
        } catch (error) {
          console.log(error);
        }
      })
      .catch(err => {
        showError(g, err, `Error Submit Form`)
      })
  },
}